export default __webpack_public_path__ + "static/media/saayaHealthLogo.15edfbca.webp";